<template>
  <el-config-provider :message="config.message">
    <div class="app-wrapper">
      <!-- 居中容器 -->
      <div class="center-container">
        <!-- 左右布局容器 -->
        <div class="main-container">
          <!-- 左侧内容区 (3/4) -->
          <Content>
            <router-view v-slot="{ Component }">
              <component :is="Component" :key="$route.name" />
            </router-view>
          </Content>

          <!-- 右侧浮动菜单 (1/4) -->
          <Aside />
        </div>
      </div>
    </div>
  </el-config-provider>
</template>

<script setup>
import { ElConfigProvider } from "element-plus";
import Aside from "@/layouts/Aside.vue";
import Content from "@/layouts/Content.vue";

// 全局消息配置
const config = {
  message: {
    max: 3,
    duration: 3000,
    customClass: "custom-message",
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #e0e0e0;
  min-height: 100vh;
  background-color: #141414;
}

.app-wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: #141414;
}

.center-container {
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #1a1b1b;
  position: relative;
  border-left: 1px solid #2a2b2b;
  border-right: 1px solid #2a2b2b;
}

.main-container {
  width: 100%;
  position: relative;
  min-height: 100vh;
}

/* 响应式设计 */
@media (max-width: 1440px) {
  .center-container {
    max-width: 1200px;
  }
}

@media (max-width: 1280px) {
  .center-container {
    max-width: 1000px;
  }
}

@media (max-width: 1024px) {
  .center-container {
    max-width: 900px;
  }
}

@media (max-width: 768px) {
  .center-container {
    max-width: 100%;
  }
}
</style>
